import React from 'react';
import intl from 'react-intl-universal';
import PropTypes from 'prop-types';
import { formatDate } from 'src/helpers/date';
import AutocompleteBase from './AutocompleteBase';
import SearchIcon from '@material-ui/icons/Search';
import Cancel from '@material-ui/icons/Cancel';
import { components } from 'react-select';
import { random } from 'lodash';
// import Avatar from 'src/ui/library/Avatar';

class Autocomplete extends React.Component {
  static propTypes = {
    /** Pre-defined custom styles to override AutocompleteBase */
    styleType: PropTypes.string,
  };

  static defaultProps = {
    styleType: 'default',
  };

  getSettings = type => {
    switch (type) {
      case 'emailCases':
        return {
          renderOption: props => {
            const { caseName, name, engagement } = props.data;
            return (
              <components.Option {...props}>
                <div className="autocomplete-item-company">{caseName}</div>
                <div className="autocomplete-item-email" style={{ marginLeft: '10px' }}>
                  {name}
                </div>
                <div className="autocomplete-item-name" style={{ marginLeft: '10px' }}>
                  {intl.get('messaging.details.caseId')}: {engagement}
                </div>
              </components.Option>
            );
          },
          renderValue: props => {
            const { caseName, name, engagement } = props.data;
            return (
              <components.SingleValue {...props}>
                <span>{`${caseName}, ${name}, ${engagement}`} </span>
              </components.SingleValue>
            );
          },
        };
      case 'email':
        return {
          renderOption: props => {
            const { name, email } = props.data;
            return (
              <components.Option {...props}>
                <div className="autocomplete-item-name">{name}</div>
                <div className="autocomplete-item-email">{email}</div>
              </components.Option>
            );
          },
          renderValue: props => {
            const { name, email } = props.data;
            return (
              <components.MultiValueLabel {...props}>
                <span>{name} </span>
                <strong className="item-email">{`(${email})`}</strong>
              </components.MultiValueLabel>
            );
          },
          renderRemove: props => {
            return (
              <components.MultiValueRemove {...props}>
                <Cancel className="del-icon" />
              </components.MultiValueRemove>
            );
          },
        };

      case 'addEmployee':
        return {
          renderIcon: props => {
            return !props.hasValue ? (
              <components.DropdownIndicator {...props}>
                <SearchIcon />
              </components.DropdownIndicator>
            ) : null;
          },
          renderOption: props => {
            // removed employeId used in Avatar below which is no longer in use.
            // const { fullName, account, employeeId, birthDate, email, employeeCode } = props.data;
            const { fullName, account, birthDate, email, employeeCode } = props.data;

            const randomColor = `rgb(${random(130)}, ${random(130)}, ${random(130)})`;

            let fname, lname;
            if (fullName) {
              const splitName = fullName.split(' ');
              if (splitName.length > 1) {
                fname = splitName[0].substring(0, 1).toUpperCase();
                lname = splitName[1].substring(0, 1).toUpperCase();
              } else {
                fname = splitName[0].substring(0, 1).toUpperCase();
                lname = '';
              }
            } else {
              fname = '';
              lname = '';
            }
            let { country } = props.data;
            const searchText = props.selectProps.inputValue;
            const highlight = (needle, haystack) =>
              haystack && haystack.replace(new RegExp(needle, 'gi'), str => `<strong>${str}</strong>`);

            const employeeName = `<p class="inner-content"><span class="item-content">${highlight(
              searchText,
              fullName,
            )}</span> <span class="item-engagement">${account}</span></p>`;
            if (!country) country = '-';

            return (
              <components.Option {...props}>
                <div className="autocomplete-item-icon">
                  <div className="si-profile-img" style={{ background: randomColor }}>
                    {fname + lname}
                  </div>
                  {/* <Avatar
                    person={{ id: employeeId, type: 'contact' }}
                    altText="Person profile"
                    border="0"
                    renderFallback={() => (
                      <img src={process.env.PUBLIC_URL + '/images/avatar-placeholder.svg'} border="0" alt="Person profile" />
                    )}
                  /> */}
                </div>
                <div className="autocomplete-item-name" dangerouslySetInnerHTML={{ __html: employeeName }} />
                <div className="autocomplete-item-location">
                  <p className="inner-content">
                    <span className="item-label">{intl.get('searchAdd.labels.country')}</span>
                    <span className="item-content">{country}</span>
                  </p>
                </div>
                <div className="autocomplete-item-dob">
                  <p className="inner-content">
                    <span className="item-label">{intl.get('searchAdd.labels.dateOfBirth')}</span>
                    <span className="item-content">{formatDate(birthDate)}</span>
                  </p>
                </div>
                <div className="autocomplete-item-email">
                  <p className="inner-content">
                    <span className="item-label">{intl.get('searchAdd.labels.email')}</span>
                    <span className="item-content">{email}</span>
                  </p>
                </div>
                <div className="autocomplete-item-employeeCode">
                  <p className="inner-content">
                    <span className="item-label">{intl.get('searchAdd.labels.employeeCode')}</span>
                    <span className="item-content">{employeeCode}</span>
                  </p>
                </div>
              </components.Option>
            );
          },
          renderValue: props => {
            const { fullName } = props.data;
            return (
              <components.SingleValue {...props}>
                <span className="value-searchadd">{fullName}</span>
              </components.SingleValue>
            );
          },
        };

      case 'lineManager':
        return {
          renderIcon: props => {
            return !props.hasValue ? (
              <components.DropdownIndicator {...props}>
                <SearchIcon />
              </components.DropdownIndicator>
            ) : null;
          },
          renderOption: props => {
            const { firstName, lastName, employer, email } = props.data;
            const searchText = props.selectProps.inputValue;
            // swapped when CPS provides avatars finally
            const avatarURL = process.env.PUBLIC_URL + '/images/avatar-placeholder.svg';
            const highlight = (needle, haystack) =>
              haystack && haystack.replace(new RegExp(needle, 'gi'), str => `<strong>${str}</strong>`);

            const employeeName = `<p class="inner-content"><span class="item-content">${highlight(
              searchText,
              firstName + ' ' + lastName,
            )}</span> <span class="item-engagement">${employer}</span></p>`;

            return (
              <components.Option {...props}>
                <div className="autocomplete-item-icon">
                  <img src={avatarURL} border="0" alt="Person profile" />
                </div>
                <div className="autocomplete-item-name" dangerouslySetInnerHTML={{ __html: employeeName }} />

                <div className="autocomplete-item-email">
                  <p className="inner-content">
                    <span className="item-label">Email</span>
                    <span className="item-content">{email}</span>
                  </p>
                </div>
              </components.Option>
            );
          },
          renderValue: props => {
            const { firstName } = props.data;
            return (
              <components.SingleValue {...props}>
                <span className="value-serviceinit">{firstName}</span>
              </components.SingleValue>
            );
          },
        };

      case 'casesLanding':
        return {
          renderIcon: props => {
            return !props.hasValue ? (
              <components.DropdownIndicator {...props}>
                <SearchIcon />
              </components.DropdownIndicator>
            ) : null;
          },
          renderOption: props => {
            const { firstName, lastName, emailId, engagement } = props.data;
            return (
              <components.Option {...props}>
                <div className="autocomplete-item-name">{`${firstName} ${lastName}`}</div>
                <div className="autocomplete-item-email">{emailId}</div>
                <div className="autocomplete-item-company">{engagement}</div>
              </components.Option>
            );
          },
          renderValue: props => {
            const { firstName, lastName, emailId } = props.data;
            return (
              <components.SingleValue {...props}>
                <span className="value-case">{`${firstName} ${lastName}`} </span>
                <strong>{`(${emailId})`}</strong>
              </components.SingleValue>
            );
          },
        };
      case 'addEmployer':
        return {
          renderIcon: props => {
            return !props.hasValue ? (
              <components.DropdownIndicator {...props}>
                <SearchIcon />
              </components.DropdownIndicator>
            ) : null;
          },
          renderOption: props => {
            const { displayText } = props.data;
            return (
              <components.Option {...props}>
                <div className="autocomplete-item">
                  <p className="inner-content">
                    <span className="item-content">{displayText}</span>
                  </p>
                </div>
              </components.Option>
            );
          },
          renderValue: props => {
            const { displayText } = props.data;
            return (
              <components.SingleValue {...props}>
                <span className="value-searchadd">{displayText}</span>
              </components.SingleValue>
            );
          },
        };
      default:
        return {};
    }
  };

  render() {
    const { styleType } = this.props;
    const settings = this.getSettings(styleType);

    return <AutocompleteBase {...settings} {...this.props} />;
  }
}

export default Autocomplete;
